import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=071f9bbb&scoped=true"
import script from "./UploadComponent.vue?vue&type=script&lang=js"
export * from "./UploadComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadComponent.vue?vue&type=style&index=0&id=071f9bbb&prod&scoped=true&lang=scss"
import style1 from "./UploadComponent.vue?vue&type=style&index=1&id=071f9bbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f9bbb",
  null
  
)

export default component.exports